<template>
	<div>
		<div>
			<Button type="primary" v-if="userInfo.role_type ==1" @click="handleTabsSystemAdd" size="small"
				slot="extra">+发布系统通知</Button>
			<Button type="primary" v-if="userInfo.role_type ==4 || userInfo.role_type ==1" @click="handleTabsAdd"
				size="small" slot="extra" style="margin-left: 10px">+发布商户通知</Button>
			<Button type="primary" v-if="userInfo.role_type ==4 || userInfo.role_type ==1" @click="autoMessageSetting"
				size="small" slot="extra" style="margin-left: 10px">自动发布通知设置</Button>
		</div>
		<Row :gutter="16">

			<Col span="24">
			<Tabs type="card" :animated="false" @on-click="tabsClick" v-model="currentTab">
				<InformTabel @getNotReadNoticeCount="getNotReadNoticeCount" :type="type" ref="all"></InformTabel>
			</Tabs>
			</Col>
		</Row>
		<Modal v-model="modal" footer-hide width="600">
			<div style="color: #000000;font-weight: bold;">发布公司公告</div>
			<Form :model="noticeInfo" :label-width="80">
				<FormItem label="公告内容">
					<div>
						<Input type="textarea" :rows="3" v-model="noticeInfo.content" placeholder="请输入公告"></Input>
					</div>
					<div style="margin-top: 10px;">
						<Button @click="noVisitClick" :data-type="2" type="primary">昨日零上门</Button>
					</div>

				</FormItem>
				<FormItem label="显示时长">
					<Input type="text" v-model="noticeInfo.last_days" placeholder="请输入显示时长">
					<span slot="append">分钟</span>
					</Input>
				</FormItem>
			</Form>
			<div style="width: 100%; display: flex; justify-content: flex-end;"><Button @click="publishNotice"
					:data-type="2" type="primary">确认发布</Button></div>
		</Modal>
		<!-- 发布通知弹出框 -->
		<Modal v-model="systemModal" footer-hide width="600">
			<div style="color: #000000;font-weight: bold;">发布系统公告</div>
			<Form :model="noticeInfo" :label-width="80">
				<FormItem label="公告内容">
					<Input type="textarea" :rows="3" v-model="noticeInfo.content" placeholder="请输入公告"></Input>
				</FormItem>
			</Form>
			<div style="width: 100%; display: flex; justify-content: flex-end;"><Button @click="publishNotice"
					:data-type="1" type="primary">确认发布</Button></div>
		</Modal>
		<Modal v-model="autoSettingModal" footer-hide width="1200">
			<AutoInformSetting></AutoInformSetting>
		</Modal>		
	</div>


</template>

<script>
	import TopBar from '../topbar/TopBar.vue'
	import InformTabel from './InformTabel.vue'
	import AutoInformSetting from './AutoInformSetting.vue'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		saveShopPublishNotice,
		getNotReadNoticeCount,
		noVisitUser
	} from '@/api/notice.js'
	export default {
		name: "InformCenter",
		components: {
			TopBar,
			InformTabel,
			AutoInformSetting
		},
		computed: {
			...mapGetters(['userInfo', 'token'])
		},
		data() {
			return {
				type: 0,
				autoSettingModal:false,
				noticeInfo: {
					content: '',
					last_days: '',
					time: '',
					remind: '',
					top: false
				},
				cityList: [{
					value: 'norRemind',
					label: '不提醒'
				}],
				systemModal: false, // 发布系统公告显示框
				modal: false, //发布商户通知显示框
				informNumber: { //未读通知个数
					team: 0,
					task: 0,
					system: 0,
					thread: 0
				},
				sumOfNoReadInform: '',
				currentTab: 'all',
				isReadType: 2,
				lastNoReadInform: {},
				lastReadInfor: {},
				team: (h) => {
					return h('div', [
						h('span', '公司通知'),
						h('span', {
							domProps: {
								innerHTML: '(' + this.informNumber.team + ')'
							},
							style: {
								color: 'red',
								fontSize: '14px'
							},
						})
					])
				},
				task: (h) => {
					return h('div', [
						h('span', '任务通知'),
						h('span', {
							domProps: {
								innerHTML: '(' + this.informNumber.task + ')'
							},
							style: {
								color: 'red',
								fontSize: '14px'
							},
						})
					])
				},
				system: (h) => {
					return h('div', [
						h('span', '系统通知'),
						h('span', {
							domProps: {
								innerHTML: '(' + this.informNumber.system + ')'
							},
							style: {
								color: 'red',
								fontSize: '14px'
							},
						})
					])
				},
				thread: (h) => {
					return h('div', [
						h('span', '客户通知'),
						h('span', {
							domProps: {
								innerHTML: '(' + this.informNumber.thread + ')'
							},
							style: {
								color: 'red',
								fontSize: '14px'
							},
						})
					])
				},
			}
		},
		mounted: function() {
			console.log(this.userInfo)
			this.$refs['all'].getNoticeInfoByType();
			this.getNotReadNoticeCount();
		},
		methods: {
			...mapActions([
				'getUserInfo',
			]),
			autoMessageSetting(){
				this.autoSettingModal = true;
			},
			// 点击标签
			tabsClick(e) {
				let that = this;
				this.$refs['all'].isReadType = this.isReadType
				switch (e) {
					case 'all':
						this.type = 0;
						this.$refs['all'].isReadType = this.isReadType
						setTimeout(function() {
							that.$refs['all'].getNoticeInfoByType();
						}, 500);
						break;
					case 'team': //2 公司通知
						this.type = 2;
						this.$refs['team'].isReadType = this.isReadType
						setTimeout(function() {
							that.$refs['team'].getNoticeInfoByType();
						}, 500);
						break;
					case 'task': //3 任务通知
						this.type = 3;
						this.$refs['task'].isReadType = this.isReadType
						setTimeout(function() {
							that.$refs['task'].getNoticeInfoByType();
						}, 500);
						break;
					case 'system': //1 系统通知
						this.type = 1;
						this.$refs['system'].isReadType = this.isReadType
						setTimeout(function() {
							that.$refs['system'].getNoticeInfoByType();
						}, 500);
						break;
					case 'thread': //4 线索通知
						this.type = 4;
						this.$refs['thread'].isReadType = this.isReadType
						setTimeout(function() {
							that.$refs['thread'].getNoticeInfoByType();
						}, 500);
						break;
				}
			},
			// 点击菜单
			menuClick(e) {
				//this.isReadType = e;
				switch (e) {
					case 'all': //所有
						this.currentTab = 'all'
						this.isReadType = 2
						this.type = 0;
						this.$refs['all'].isReadType = 2;
						this.$refs['all'].getNoticeInfoByType();
						this.getNotReadNoticeCount()
						break;

					case 'unread': //所有未读
						this.currentTab = 'all'
						this.isReadType = 0;
						this.type = 0;
						this.$refs['all'].isReadType = 0;
						this.$refs['all'].getNoticeInfoByType();
						this.getNotReadNoticeCount()
						break;

					case 'read': //所有已读
						this.currentTab = 'all'
						this.isReadType = 1
						this.type = 0;
						this.$refs['all'].isReadType = 1;
						this.$refs['all'].getNoticeInfoByType();
						this.getNotReadNoticeCount()
						break;
				}

			},
			handleTabsAdd() {
				this.modal = true
			},
			handleTabsSystemAdd() {
				this.systemModal = true
			},
			//获取昨日上门为0客户经理
			async noVisitClick() {
				let that = this;
				let data = {
					token: that.token
				}
				let res = await noVisitUser(that, data);
				that.noticeInfo.content = '昨日0上门：' + res.data.text;


			},
			// 确认发布
			publishNotice(e) {
				let that = this;
				let type = e.currentTarget.dataset.type;
				let data = {
					token: that.token,
					noticeContent: that.noticeInfo.content,
					type: type,
					lastDays: that.noticeInfo.last_days
				}
				saveShopPublishNotice(data).then(function(res) {
					if (res.data.code == 1) {
						that.noticeInfo.content = '';
						that.getNotReadNoticeCount();
						that.modal = false;
						that.systemModal = false;
						that.getUserInfo();
						that.$refs[that.currentTab].getNoticeInfoByType();
						that.$Message.success('发布成功');
					} else {
						that.$Message.warning('发布失败');
					}
				});
				this.modal = false
			},

			//获取未读通知的个数
			getNotReadNoticeCount() {

				if (this.isReadType == 1) {
					this.informNumber.team = 0;
					this.informNumber.task = 0;
					this.informNumber.system = 0;
					this.informNumber.thread = 0;
				} else {
					let that = this
					let data = {
						token: that.token
					}
					getNotReadNoticeCount(data).then(function(res) {
						that.informNumber = res.data.data
						that.sumOfNoReadInform = res.data.data.sum
					});
				}

			},
		},


	}
</script>

<style scoped lang="less">

</style>